var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import FileUploadManager from "./FileUploadManager";
import * as path from "path-browserify";
import * as BluebirdPromise from "bluebird";
export default class BatchUploadManager {
    constructor(axios, options) {
        this.uploadBatch = (files, batchNumber) => BluebirdPromise.map(files, (file) => new Promise((resolve, reject) => {
            const fileUploadStartTime = Date.now();
            const uploadFile = new FileUploadManager(this.axios, file, {
                bspHost: this.options.bspHost,
                customerId: this.options.customerId,
                siteId: this.options.siteId,
                uploadPath: path.join(this.options.uploadPath, batchNumber.toString()),
                getJwtToken: this.options.getJwtToken,
                metricFunction: this.options.metricFunction,
                logFunction: this.options.logFunction,
                maxRetries: Infinity,
                maxParallelRequests: this.options.maxParallelRequests,
                retryIntervalMs: this.options.retryIntervalMs,
                requestTimeoutMs: this.options.requestTimeoutMs,
                onUploadCompleted: (event) => __awaiter(this, void 0, void 0, function* () {
                    const fileUploadTimeSeconds = Math.round((Date.now() - fileUploadStartTime) / 1000);
                    const speedBytesPerSeconds = file.size / fileUploadTimeSeconds;
                    this.onSingleFileUploadCompleted(event.file, event.filePath, speedBytesPerSeconds);
                    resolve(event.filePath);
                }),
                onUploadFailed: (error) => {
                    reject(error);
                },
                extraHeaders: this.options.extraHeaders,
            });
            uploadFile.startUpload();
        }), {
            concurrency: this.options.maxParallelFiles,
        });
        this.axios = axios;
        this.options = Object.assign({ partSizeBytes: 5 * 1024 * 1024, requestTimeoutMs: 60 * 1000, retryIntervalMs: 2 * 1000, maxParallelRequests: 4, maxParallelFiles: 4, extraHeaders: {} }, options);
        this.files = [];
        this.uploadedFilePaths = [];
        this.batchCount = 0;
    }
    isBatchUploadInProgress() {
        return this.batchUploadInProgress;
    }
    startUpload(files) {
        (() => __awaiter(this, void 0, void 0, function* () {
            this.batchUploadInProgress = true;
            this.files.push(...files);
            this.batchCount++;
            yield this.uploadBatch(files, this.batchCount);
            if (this.files.length === this.uploadedFilePaths.length) {
                this.onBatchUploadCompleted();
            }
        }))();
    }
    onBatchUploadCompleted() {
        this.batchUploadInProgress = false;
        this.options.onUploadCompleted({
            filePaths: this.uploadedFilePaths,
        });
    }
    onSingleFileUploadCompleted(file, filePath, speedBytesPerSeconds) {
        this.uploadedFilePaths.push(filePath);
        this.options.onFileUploaded(this.uploadedFilePaths.length, this.files.length, speedBytesPerSeconds, file, filePath);
    }
}
//# sourceMappingURL=BatchUploadManager.js.map